import React, { useEffect, useRef, useState } from 'react';
//Header Data

//Footer Data

import { Contest, User } from '../../global';
// import PopUpSaveDraft from '../../components/PopUp/PopUpSaveDraft/PopUpSaveDraft';
import { useAuth } from '../../context/AuthContext';
import ContestSidePart from './ContestSidePart';
import ProfileForUpload from '../../components/Profile/Editors/ProfileForUpload';
import UploadComponent from '../../components/Design/UploadComponent/UploadComponent';
import { useBanner } from '../../context/BannerContext';
import { briefUrlForContest } from '../../helpers/navigationUtils';
import { useNavigate } from 'react-router-dom';
import { computeContestPhase } from '../../helpers/contestUtilities';
import { checkUserForUpload } from '../../helpers/utilities';

interface Props {
  contest: Contest;
  setPopupMessage: (value: boolean) => void;
}

const UploadContestWLF: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const { createAndAddBannerMessage } = useBanner();
  const { loggedUser, setLoggedUser } = useAuth();
  const [needUserData, setNeedUserData] = useState(false);
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    if (shouldRedirect) {
      navigate(briefUrlForContest(props.contest));
    }
  }, [shouldRedirect, navigate]);

  useEffect(() => {
    if (loggedUser) {
      if (computeContestPhase(props.contest) === 'upload-phase' && loggedUser.userType === 'D' && !props.contest.needsAccessCode && !props.contest.needsNDA) {
        setNeedUserData(!checkUserForUpload(loggedUser));
      } else {
        createAndAddBannerMessage('Access denied', 'error', 'access-denied' + props.contest.id);
        setShouldRedirect(true);
      }
    } else {
      createAndAddBannerMessage('Access denied', 'error', 'access-denied' + props.contest.id);
      setShouldRedirect(true);
    }
  }, [props, loggedUser]);

  if (!loggedUser) {
    console.log('User not logged in');
    // createAndAddBannerMessage('Access denied without login', 'error');
    return null;
  } else
    return (
      <div className="bg-light-gray ">
        <main className={`container pt-5 mb-5 px-sm-0  overflow-hidden `}>
          <div className="row ">
            <ContestSidePart contest={props.contest} disableUpload={true} setPopupMessage={props.setPopupMessage} />
            <div className="col-12 col-md-9 pt-5  px-5 px-sm-0">
              <div className="row">
                <div className="col-12 px-4 ">
                  <div className="row-mb-5">
                    <div className="col-12 col-md-2 mb-3"></div>
                    <div className="col-12 col-md-10"></div>
                  </div>
                </div>
              </div>
              {needUserData ? (
                <ProfileForUpload
                  user={loggedUser}
                  setUser={(rst) => {
                    setLoggedUser(rst);
                    setNeedUserData(false);
                  }}
                />
              ) : (
                <UploadComponent contest={props.contest} setPopupMessage={props.setPopupMessage} />
              )}
            </div>
          </div>

          {/* <PopUpSaveDraft
            popupVisible={saveDraftPopupVisible}
            onClose={() => {
              setSaveDraftPopupVisible(false);
              setProgress(0);
            }}
            onAccept={() => {
              console.log('accept');
              setSaveDraftPopupVisible(false);
              draft.current = true;
              setProgress(1);
              // trigger();
              handleSubmit(onSubmit)();
            }}
          /> */}
        </main>
      </div>
    );
};

export default UploadContestWLF;
